import { $, api } from "./api";
import { hideMessage, showMessage } from "./ui";

const form = $<HTMLFormElement>("form");
const button = form.querySelector<HTMLButtonElement>("button[type=submit]")!;

form.addEventListener("submit", async (e) => {
  e.preventDefault();
  hideMessage("error");
  const email = $<HTMLInputElement>("email").value.trim();
  if (!email) return showMessage("error", "Please enter your email.");
  button.disabled = true;
  try {
    await api("/api/forgot-password", { method: "POST", body: { email } });
    $("sent-to").textContent = email;
    $("ask").hidden = true;
    $("sent").hidden = false;
    $("sent").querySelector("h1")?.focus();
  } catch (err) {
    showMessage("error", (err as Error).message);
  } finally {
    button.disabled = false;
  }
});
